import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import {
  DeliveryPackage,
  deliveryPackages,
  ProductTypes,
  DeliveryPackageNames,
} from "../../file.interface";
import { formatAsEuro } from "../../helpers/helpers";
import { ScreenContainer } from "../../components/containers";

const DeliveryScreen5: React.FC = () => {
  //
  const { dispatch, sites, selectedDeliveryPackage } = useAppContext();
  const navigate = useNavigate();

  const [customDeliveryPackages, setCustomDeliveryPackages] = useState<
    DeliveryPackage[]
  >([]);

  useEffect(() => {
    showDeliveryPackages();
  }, []);

  const showDeliveryPackages = () => {
    let customPackage: DeliveryPackage[] = [];
    let pack1Info: DeliveryPackage = deliveryPackages[0];
    let pack2Info: DeliveryPackage = deliveryPackages[1];
    let pack3Info: DeliveryPackage = deliveryPackages[2];
    let pack4Info: DeliveryPackage = deliveryPackages[3];
    let sitesCounter: number = sites.length;
    let devicesCounter: number = 0;
    let eposCounter: number = 0;
    let terminalsCounter: number = 0;

    sites.forEach((site) => {
      //
      eposCounter += site.cart.reduce(
        (total: number, item) =>
          item.type === ProductTypes.Epos ? total + 1 : total,
        0
      );
      terminalsCounter += site.cart.reduce(
        (total: number, item) =>
          item.type === ProductTypes.Terminals ? total + 1 : total,
        0
      );
    });

    devicesCounter = eposCounter + terminalsCounter;

    if (sitesCounter === 1) {
      // including package 1
      customPackage.push(pack1Info);
    }

    if (devicesCounter > 0 && devicesCounter <= 3) {
      //inlcuding package 2
      customPackage.push({
        ...pack2Info,
        price: pack2Info.price * sitesCounter,
      });
    }

    if (devicesCounter > 3) {
      //including package 3
      customPackage.push({
        ...pack3Info,
        price: pack3Info.price * sitesCounter,
      });
    }
    if (devicesCounter && sitesCounter) customPackage.push(pack4Info);

    setCustomDeliveryPackages(customPackage);
  };

  const handlePackage = (_package: DeliveryPackage): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedDeliveryPackage: _package },
    });
  };

  return (
    <ScreenContainer
      title="Hardware Delivery & Installation"
      subtitle="Choose one of the following packages"
    >
      <div className="package-container">
        {customDeliveryPackages.map((_package, i) => {
          //
          let packagePrice: string | number = _package.priceDescription;
          if (
            DeliveryPackageNames.complete === _package.packageName ||
            DeliveryPackageNames.allInOne === _package.packageName
          )
            packagePrice = formatAsEuro(_package.price);
          return (
            <div
              key={i}
              className={`${
                _package === selectedDeliveryPackage
                  ? "card-package-selected"
                  : ""
              } card-package`}
              onClick={() => handlePackage(_package)}
            >
              <div className="price-section">
                <div className="orange-title">{_package.packageName}</div>
                <div className="package-price">{packagePrice}</div>
              </div>
              {_package.recommended && (
                <div className="green-tag">RECOMMENDED</div>
              )}
              <ul>
                {_package.description.split("\n").map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      <p className="disclaimer">
        ** 30 min in Person ‘Activation’ Training will include: Logging in,
        Process a sale/refund, Process of payment and how to find online help
        guides/videos (how to use the manuals)
      </p>
      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>

        {selectedDeliveryPackage && (
          <button
            className="app-button next-button"
            onClick={() => navigate("/product-conf-screen-5")}
          >
            Next
          </button>
        )}
      </div>
    </ScreenContainer>
  );
};

export default DeliveryScreen5;
